import { useEffect } from 'react';

export function usePromptBeforeUnload(shouldTriggerPromptYn: boolean): void {
    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            if (shouldTriggerPromptYn) {
                event.preventDefault();
                event.returnValue = 'prompt user'; // this does not really matter
            }
        };

        globalThis.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            globalThis.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [shouldTriggerPromptYn]);
}
